// extracted by mini-css-extract-plugin
export default {"roundedDiv":"AcountSettings_roundedDiv__lRQoQ","rowBorded":"AcountSettings_rowBorded__U9kWc"};